import css from "standard/css";

const style = css`
  .upload {
    display: flex;
    flex-direction: column;
    gap: var(--spacing_inset-xs);
    max-width: 768px;
    width: 100%; 
  }

  .upload__title {
    color: var(--color-master-dark);
    font-family: var(--font-family-highlight);
    font-size: var(--font-size-md);
    font-weight: var(--font-weight-medium);
    font-weight: var(--font-weight-bold);
    line-height: var(--line-height-lg);
    font-family: var(--font-family-highlight);
    font-size: var(--font-size-md);
  }

  .upload__container {
    align-items: center;
    border: var(--border-width-thick) dashed #A5A5A5;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    gap: var(--spacing_inset-md);
    padding: var(--spacing-xl) var(--spacing_inset-xs);
  }

  .upload__h4 {
    color: var(--color-master-dark);
    font-family: var(--font-family-highlight);
    font-size: var(--font-size-md);
    font-weight: var(--font-weight-bold);
    line-height: var(--line-height-lg);
    font-family: var(--font-family-highlight);
    font-size: var(--font-size-lg);
    text-align: center;
  }

  .upload__preference {
    color: #444;
    font-family: var(--font-family-base);
    font-size: var(--font-size-md);
    font-weight: var(--font-weight-medium);
  }

  .upload__label {
    align-items: center;
    background-color: var(--color-complete);
    border: none;
    border-bottom: 2px solid var(--color-complete-light);
    border-radius: 12px;
    box-shadow: 0 10px 0 var(--color-complete-dark);
    color: var(--color-pure-white);
    cursor: pointer;
    display: flex;
    font-family: var(--font-family-base);
    font-size: 18px;
    font-weight: var(--font-weight-bold);
    line-height: 1;
    justify-content: center;
    margin-top: calc(var(--spacing_inset-xs) * -1);
    padding: var(--spacing_inset-xs) var(--spacing-md);
    text-align: center;
    width: fit-content;
  }

  .upload__label:active {
    box-shadow: none;
    transform: translateY(5px);
  }

  .upload__limit {
    color: #444;
    display: flex;
    font-family: var(--font-family-base);
    font-size: var(--font-size-xs);
    font-weight: var(--font-weight-regular);
    margin-top: calc(var(--spacing_inset-nano) * -1);
  }

  .upload__input {
    cursor: pointer;
    display: none !important;
    opacity: 0;
    position: absolute;
  }
`;

export default style;
